module.exports = __webpack_public_path__ + "img/icon40.38e1cd9d.svg";